var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "#222222",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.332 14.7254V27.9348C29.332 28.7474 29.2047 29.531 28.9691 30.268C27.9739 33.3862 25.0409 35.6614 21.6054 35.6614H0.66803V14.7254C0.66803 10.4759 4.1452 6.99875 8.39464 6.99875H21.6041C25.8535 6.99875 29.332 10.4759 29.332 14.7254Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7767 6.90929C21.7767 6.93952 21.7767 6.97102 21.7692 7.00125H19.7786C19.771 6.97102 19.771 6.93952 19.771 6.90929C19.771 4.28125 17.6306 2.14078 15.0025 2.14078C12.3707 2.14078 10.2303 4.28125 10.2303 6.90929C10.2303 6.93952 10.2303 6.97102 10.2265 7.00125H8.23089C8.22333 6.96724 8.22333 6.93952 8.22333 6.90929C8.22333 3.17259 11.2658 0.13385 15.0025 0.13385C18.7392 0.13385 21.7767 3.17259 21.7767 6.90929Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.234 6.97983C10.234 7.5329 9.78554 7.9814 9.23247 7.9814C8.6794 7.9814 8.2309 7.5329 8.2309 6.97983H10.234Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7515 6.97983C21.7515 7.5329 21.303 7.9814 20.7499 7.9814C20.1969 7.9814 19.7484 7.5329 19.7484 6.97983H21.7515Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7291 22.6535C22.7291 26.9496 19.2469 30.4318 14.9509 30.4318C10.6548 30.4318 7.17261 26.9496 7.17261 22.6535",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6095098e.svg";
export { ForwardRef as ReactComponent };